module.exports = __webpack_public_path__ + "img/city.90f85953.svg";